// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"da2be99b","87":"4212a7ef","154":"2c09ef5e","207":"c1264577","223":"f80d22b3","240":"fcba5406","256":"d6330a5b","259":"f1971485","496":"0d72fc44","635":"ac4739c9","761":"92b6f1d7","846":"8214093a","897":"95d54800","934":"c5860ad4","985":"7fecfd72"}[chunkId] + ".chunk.js";
};